import { lazy, Suspense } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));

// Dealer Meeting Pages
export const OpenHousePresentationPage = Loadable(
  lazy(() => import('../pages/OpenHousePresentation'))
);
export const OpenHouseBoatsPage = Loadable(lazy(() => import('../pages/OpenHouseBoats')));

// Dealer Book Pages----------------------------------------------------------------------
export const BoatPriceListPage = Loadable(lazy(() => import('../pages/BoatPriceList')));
export const DealerinvoicesPage = Loadable(lazy(() => import('../pages/DealerInvoices')));
export const ViewInvoicePage = Loadable(lazy(() => import('../pages/ViewInvoice')));
export const ViewOrderPage = Loadable(lazy(() => import('../pages/ViewOrder')));
export const BoatOrderPage = Loadable(lazy(() => import('../pages/DealerOrders')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const MotorPriceListPage = Loadable(lazy(() => import('../pages/MotorPriceList')));
export const OptionPriceListPage = Loadable(lazy(() => import('../pages/OptionPriceList')));

// Marketing Pages----------------------------------------------------------------------
export const ModelGalleryPage = Loadable(lazy(() => import('../pages/ModelGallery')));
export const ModelGalleryUploadPage = Loadable(lazy(() => import('../pages/ModelGalleryUpload')));
export const AvalonBrochuresPage = Loadable(lazy(() => import('../pages/AvalonBrochures')));
export const TahoeBrochuresPage = Loadable(lazy(() => import('../pages/TahoeBrochures')));
export const MarketingToolsPage = Loadable(lazy(() => import('../pages/MarketingTools')));
export const AvalonVideosPage = Loadable(lazy(() => import('../pages/AvalonVideos')));
export const TahoeVideosPage = Loadable(lazy(() => import('../pages/TahoeVideos')));
export const ImportantInfoPage = Loadable(lazy(() => import('../pages/ImportantInfo')));
export const MarketingStrategy = Loadable(lazy(() => import('../pages/Marketingstrategy')));
export const Instoremarketing = Loadable(lazy(() => import('../pages/Instoremarketing')));

// Training Pages----------------------------------------------------------------------
export const TrainingDayPage = Loadable(lazy(() => import('../pages/TrainingDay')));
export const AvalonProductTraining = Loadable(lazy(() => import('../pages/AvalonProductTraining')));
export const TahoeProductTraining = Loadable(lazy(() => import('../pages/TahoeProductTraining')));
export const DamagedEngineProcess = Loadable(lazy(() => import('../pages/DamagedEngineProcess')));
export const AvalonModelComparison = Loadable(lazy(() => import('../pages/AvalonModelComparison')));
export const TahoeModelComparison = Loadable(lazy(() => import('../pages/TahoeModelComparison')));
export const AvalonWaketoonTraining = Loadable(
  lazy(() => import('../pages/AvalonWaketoonTraining'))
);
export const TahoeWaketoonTraining = Loadable(lazy(() => import('../pages/TahoeWaketoonTraining')));

// Paper Form Pages--------------------------------------------------------------------
export const CoOpClaimForm = Loadable(lazy(() => import('../pages/CoOpClaimForm')));
export const NewOwnerAdvisoryChecklist = Loadable(
  lazy(() => import('../pages/NewOwnerAdvisoryChecklist'))
);
export const QuickOrderForm = Loadable(lazy(() => import('../pages/QuickOrderForm')));
export const ReturnGoodsForm = Loadable(lazy(() => import('../pages/ReturnGoodsForm')));
export const MSORequest = Loadable(lazy(() => import('../pages/MSORequest')));
export const SpecSheetsPage = Loadable(lazy(() => import('../pages/SpecSheets')));
export const CoOpPage = Loadable(lazy(() => import('../pages/CoOp')));

// Warranty Pages----------------------------------------------------------------------
export const WarrantyRegistrationPage = Loadable(
  lazy(() => import('../pages/WarrantyRegistrationTable'))
);
export const WarrantyRegistrationForm = Loadable(
  lazy(() => import('../pages/WarrantyRegistrationForm'))
);
export const WarrantyClaimForm = Loadable(lazy(() => import('../pages/WarrantyClaimForm')));
// ----------------------------------------------------------------------
export const WarrantyTransferPage = Loadable(lazy(() => import('../pages/WarrantyTransfer')));
export const WrittenWarrantyPage = Loadable(lazy(() => import('../pages/WrittenWarranty')));
export const WarrantyProcedurePage = Loadable(lazy(() => import('../pages/WarrantyProcedure')));
export const PaperWarrantyClaimPage = Loadable(lazy(() => import('../pages/PaperWarrantyClaim')));
export const ViewWarrantyRegistration = Loadable(
  lazy(() => import('../sections/forms/ViewWarrantyRegistration'))
);
export const DealerWarrantyClaimTracker = Loadable(
  lazy(() => import('../pages/DealerWarrantyClaimTracker'))
);

// Customer Service Pages----------------------------------------------------------------------
export const ServicePartsPricingPage = Loadable(lazy(() => import('../pages/ServicePartsPricing')));
export const RegionalMapPage = Loadable(lazy(() => import('../pages/RegionalMap')));
export const ServiceOrderPage = Loadable(lazy(() => import('../pages/ServiceOrder')));
export const TechnicalInformationViewPage = Loadable(
  lazy(() => import('../pages/TechnicalInformationView'))
);
export const ScoreCardPage = Loadable(lazy(() => import('../pages/ScoreCard')));
export const ManualsViewPage = Loadable(lazy(() => import('../pages/ManualView')));
export const PartLookupPage = Loadable(lazy(() => import('../pages/PartLookup')));

export const PartLookupBoatEntry = Loadable(lazy(() => import('../pages/PartLookupBoatEntry')));
export const BoatInventoryPage = Loadable(lazy(() => import('../pages/BoatInventory')));

export const PartOrderPage = Loadable(lazy(() => import('../pages/PartOrder')));
export const RMAHome = Loadable(lazy(() => import('../pages/RMATable')));
export const PartOrderList = Loadable(lazy(() => import('../pages/PartOrderList')));
export const CreateNewManualCategory = Loadable(
  lazy(() => import('../pages/CreateNewManualCategory'))
);
export const ManualCategory = Loadable(lazy(() => import('../pages/ManualCategory')));
export const CreateManualPage = Loadable(lazy(() => import('../pages/CreateManualPage')));
// export const CreateManualSecondaryCategory = Loadable(
//   lazy(() => import('../pages/CreateManualSecondaryCategory'))
// );
export const ManualSecondaryCategory = Loadable(
  lazy(() => import('../pages/ManualSecondaryCategory'))
);

// Maintenance Portal Pages----------------------------------------------------------------------
export const MaintenancePortal = Loadable(lazy(() => import('../pages/MaintenancePortal')));
export const BulletinsAdmin = Loadable(lazy(() => import('../pages/BulletinsAdmin')));
export const EditBulletin = Loadable(lazy(() => import('../pages/EditBulletin')));
export const TechnicalInformationPrimaryCategory = Loadable(
  lazy(() => import('../pages/TechnicalInformationPrimaryCategory'))
);
export const TechnicalInformationSecondaryCategory = Loadable(
  lazy(() => import('../pages/TechnicalInformationSecondaryCategory'))
);
export const TechnicalInformation = Loadable(lazy(() => import('../pages/TechnicalInformation')));

export const TechnicalInformationViewTemp = Loadable(
  lazy(() => import('../pages/TechnicalInformationViewTemp'))
);
export const DealerPortalMaintenanceAdmin = Loadable(
  lazy(() => import('../pages/DealerPortalMaintenance'))
);

// Dealer Portal Pages----------------------------------------------------------------------
export const StockBoat = Loadable(lazy(() => import('../pages/StockBoatsPage')));
export const InvoiceTool = Loadable(lazy(() => import('../pages/InvoiceToolV2')));

export const DealerInvoiceTool = Loadable(lazy(() => import('../pages/DealerInvoiceTool')));
export const Attoonshop = Loadable(lazy(() => import('../pages/Attoonshop')));
export const Contactlist = Loadable(lazy(() => import('../pages/Contactlist')));
export const Floorplanoverview = Loadable(lazy(() => import('../pages/Floorplanoverview')));
export const FusionPackages = Loadable(lazy(() => import('../pages/FusionPackages')));
export const HistoryMissionStatement = Loadable(
  lazy(() => import('../pages/HistoryMissionStatement'))
);
export const OnlineOrders = Loadable(lazy(() => import('../pages/OnlineOrders')));
export const InternetAdvertising = Loadable(lazy(() => import('../pages/InternetAdvertising')));

export const OwnerAdvisoryChecklist = Loadable(lazy(() => import('../pages/OwnerAdvisoryList')));
export const OnlineDealerResources = Loadable(lazy(() => import('../pages/OnlineDealerResources')));
export const PaintCodes = Loadable(lazy(() => import('../pages/PaintCodes')));
export const MetalJacket = Loadable(lazy(() => import('../pages/MetalJacket')));
export const InspectionPictureLookup = Loadable(
  lazy(() => import('../pages/InspectionPictureLookup'))
);
export const InspectionPictures = Loadable(lazy(() => import('../pages/InspectionPictures')));
export const ShipperPictures = Loadable(lazy(() => import('../pages/ShipperInspectionPictures')));
export const ViewShipperPictures = Loadable(
  lazy(() => import('../pages/ShipperInspectionViewPicture'))
);
export const ViewPictureGroups = Loadable(lazy(() => import('../pages/ViewShippingPictureGroups')));
export const RMAView = Loadable(lazy(() => import('../pages/ViewRma')));
export const DealerWarrantyRegistration = Loadable(
  lazy(() => import('../pages/DealerWarrantyTable'))
);

export const DealerWarrantyRegistrationForm = Loadable(
  lazy(() => import('../pages/DealerWarrantyRegistrationForm'))
);
export const DealerWarrantyClaimForm = Loadable(
  lazy(() => import('../pages/DealerWarrantyClaimForm'))
);

// Account Pages----------------------------------------------------------------------
export const NoAuthViewInvoice = Loadable(lazy(() => import('../pages/NoAuthViewInvoice')));
export const NoAuthViewOrder = Loadable(lazy(() => import('../pages/NoAuthViewOrder')));
export const ViewStockOrder = Loadable(lazy(() => import('../pages/ViewStockOrder')));
export const ViewStatement = Loadable(lazy(() => import('../pages/ViewStatement')));
export const MaintenanceDashboard = Loadable(lazy(() => import('../pages/Dashboard')));
export const MaintenancePortalChatBot = Loadable(
  lazy(() => import('../pages/MaintenancePortalChatBot'))
);
export const TakeInspectionPictures = Loadable(
  lazy(() => import('../pages/TakeInspectionPictures'))
);

export const BarcodeScanner = Loadable(lazy(() => import('../pages/BarcodeScanner')));
export const ChangeOrderEntry = Loadable(lazy(() => import('../pages/ChangeOrderEntry')));
export const ChangeOrderTable = Loadable(lazy(() => import('../pages/ViewChangeOrderTable')));
export const ChangeOrderByBoatTable = Loadable(
  lazy(() => import('../pages/ViewChangeOrderByBoat'))
);
export const FindChangeOrder = Loadable(lazy(() => import('../pages/ChangeOrderBarcodeScanner')));
export const NoAuthViewJobTraveller = Loadable(
  lazy(() => import('../pages/NoAuthViewJobTraveller'))
);
export const ServiceOrderStatus = Loadable(lazy(() => import('../pages/ServiceOrderStatus')));
export const MotorInventory = Loadable(lazy(() => import('../pages/MotorInventory')));

export const SocialMedia = Loadable(lazy(() => import('../pages/SocialMedia')));
export const UploadSocialMedia = Loadable(lazy(() => import('../pages/UploadSocialMedia')));
export const DealerMeetingImages = Loadable(lazy(() => import('../pages/DealerMeetingImages')));
export const CSWarrantyTracker = Loadable(lazy(() => import('../pages/CSWarrantyClaimTracker')));
export const CSWarrantyTrackerViewClaim = Loadable(
  lazy(() => import('../pages/CSWarrantyTrackerViewClaim'))
);
export const DealerViewWarrantyClaim = Loadable(
  lazy(() => import('../pages/DealerViewWarrantyClaim'))
);
export const ViewCheckSheet = Loadable(lazy(() => import('../pages/ViewCheckSheet')));
